import Vue from 'vue';
import VueRouter from 'vue-router';
import { store } from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/moderasi',
    name: 'Moderasi',
    meta: {
      requiresAuth: true
    },

    component: () => import('../views/Moderasi.vue')
  },
  {
    path: '/user',
    name: 'Users',
    meta: {
      requiresAuth: true
    },

    component: () => import('../views/User.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: {
      requiresAuth: true
    },

    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/',
    name: 'Login',
    beforeEnter: (to, from, next) => {
      // to.matched.some(router.app.$store.state.token !== "null");
      // console.log('ayam', router.app.$store.state.token);
      console.log('routerrr', router.app.$store.state.token)
      if (router.app.$store.state.token !== null)
        next({
          path: '/dashboard'
        });
      else next();
    },

    component: () =>
      import(/* webpackChunkName: "Login" */ '../views/Login.vue')
  },
  {
    path: '/pembelian_tiket',
    name: 'pembelian_tiket',
    meta: {
      requiresAuth: true
    },

    component: () => import('../views/tiket/PembelianTiket.vue')
  },
  {
    path: '/transaksi',
    name: 'transaksi',
    meta: {
      requiresAuth: true
    },

    component: () => import('../views/tracking/Transaksi.vue')
  },
  {
    path: '/pengembalian_tiket',
    name: 'pengembalian_tiket',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "pengembalian_tiket" */
        '../views/tiket/PengembalianTiket.vue'
      )
  },
  {
    path: '/refund_tiket',
    name: 'refund_tiket',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "pengembalian_tiket" */
        '../views/tiket/RefundTiket.vue'
      )
  },
  {
    path: '/transfer_dana',
    name: 'transfer_dana',
    meta: {
      requiresAuth: true
    },
    component: () => import('../views/tiket/TransferDana.vue')
  },
  {
    path: '/banner',
    name: 'banner',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(/* webpackChunkName: "banner" */ '../views/setup/Banner.vue')
  },
  {
    path: '/preview/:id',
    name: 'banner',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(/* webpackChunkName: "banner" */ '../views/preview/_id.vue')
  },
  {
    path: '/module',
    name: 'module',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(/* webpackChunkName: "module" */ '../views/setup/Module.vue')
  },
  {
    path: '/category',
    name: 'category',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(/* webpackChunkName: "category" */ '../views/setup/Category.vue')
  },
  {
    path: '/role',
    name: 'role',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(/* webpackChunkName: "role" */ '../views/setup/Role.vue')
  },

  {
    path: '/jenis_iklan',
    name: 'jenis_iklan',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "jenis_iklan" */ '../views/setup/JenisIklan.vue'
      )
  },
  {
    path: '/list_transaksi',
    name: 'list_transaksi',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "list_transaksi" */
        '../views/ListTransaksi.vue'
      )
  },
  {
    path: '/list_iklan',
    name: 'list_iklan',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "list_transaksi" */
        '../views/ListIklan.vue'
      )
  },
  {
    path: '/event',
    name: 'event',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "list_transaksi" */
        '../views/Event.vue'
      )
  },
  {
    path: '/popup',
    name: 'popup',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "popup" */
        '../views/Popup.vue'
      )
  },
  {
    path: '/service',
    name: 'service',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "list_transaksi" */
        '../views/Service.vue'
      )
  },
  {
    path: '/pencairan_saldo',
    name: 'saldo',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "list_transaksi" */
        '../views/PencairanSaldo.vue'
      )
  },
  {
    path: '/detail_unit',
    name: 'detail_unit',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(/* webpackChunkName: "detail_unit" */ '../views/DetailUnit.vue')
  },

  {
    path: '/detail_iklan',
    name: 'detail_iklan',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(/* webpackChunkName: "detail_iklan" */ '../views/DetailIklan.vue')
  },
  {
    path: '/detail-iklan',
    name: 'detail-iklan',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(/* webpackChunkName: "detail_iklan" */ '../views/Detail-iklan.vue')
  },
  {
    path: '/verifikasi-user',
    name: 'verifikasi-user',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "verifikasi-user" */ '../views/VerifikasiUser.vue'
      )
  },
  {
    path: '/verifikasi-selesai',
    name: 'verifikasi-selesai',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "verifikasi-selesai" */ '../views/VerifikasiSelesai.vue'
      )
  },
  {
    path: '/Detail-pantau',
    name: 'Detail-pantau',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "DetailPantau" */ '../views/Detail-pantau.vue'
      )
  },
  {
    path: '/verifikasi-ditolak',
    name: 'verifikasi-ditolak',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "verifikasi-ditolak" */ '../views/VerifikasiDitolak.vue'
      )
  },
  {
    path: '/add-event',
    name: 'add-event',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "verifikasi-ditolak" */ '../views/AddEvent.vue'
      )
  },
  {
    path: '/verifikasi-alamat',
    name: 'verifikasi-alamat',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "verifikasi-ditolak" */ '../views/VerifikasiAlamat.vue'
      )
  },
  {
    path: '/report-iklan',
    name: 'report-iklan',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "verifikasi-ditolak" */ '../views/reports/ReportIklan.vue'
      )
  },
  {
    path: '/tipe-unit',
    name: 'tipe-unit',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "tipe-unit" */ '../views/master/TipeUnit.vue'
      )
  },
  {
    path: '/report-lelang',
    name: 'report-lelang',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(
        /* webpackChunkName: "report-iklan" */ '../views/reports/ReportLelang.vue'
      )
  },
  {
    path: '/reward-dealer',
    name: 'reward-dealer',
    meta: {
      requiresAuth: true
    },

    component: () => import('../views/RewardDealer.vue')
  },
  {
    path: '/role_menu',
    name: 'role_menu',
    meta: {
      requiresAuth: true
    },

    component: () =>
      import(/* webpackChunkName: "role_menu" */ '../views/setup/RoleMenu.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  next();
});
// Buat Login

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(record => record.meta.requiresAuth) &&
    (!router.app.$store.state.token || router.app.$store.state.token === 'null')
  )
    next({
      name: 'Login',
      path: '/',
      query: {
        redirect: to.fullPath
      }
    });
  else next();
});

if (window.localStorage) {
  const localUserString = window.localStorage.getItem('user');
  const localToken = window.localStorage.getItem('token');

  if (localUserString !== null) {
    const localUser = JSON.parse(localUserString);

    store.commit('SET_USER', localUser);
    store.commit('SET_TOKEN', localToken);
  }
}

export default router;
